// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1fe3705e","703":"323ef4de","787":"774729bc"}[chunkId] + ".chunk.js";
};